import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  clearLocalStorage,
} from "@rista/core/utils/localStorage";
// The four storage PRIMITIVES moved to @rista/core/utils/localStorage (a real platform split:
// browser localStorage here, react-native-mmkv on mobile). Imported because the helpers below
// call them, and re-exported so this file's importers are unchanged.
export { setLocalStorage, getLocalStorage, removeLocalStorage, clearLocalStorage };

import { LOCALSTORAGE_KEYS } from "./constants";

// Moved to @rista/core/utils/localStorage (index.desktop.ts — the mobile twin is in
// index.native.ts; byte-identical apart from quote style). Re-exported so this file's importers
// (helper/printHelper reads both) are unchanged.
export { USBPrinter, getAddedBlePrintersList } from "@rista/core/utils/localStorage";
// `getAddedBlePrintersList` is ALSO imported because `isBluetoothPrinterExists` below calls it
// — a re-export creates no local binding, and in a .js file that mistake is silent until it
// throws at runtime (CLAUDE.md → the ReferenceError that shipped once). `USBPrinter` needs no
// import: nothing in this file's own body calls it.
import { getAddedBlePrintersList } from "@rista/core/utils/localStorage";

// Moved to @rista/core/utils/localStorage (WEB only — mobile's copy returns "" for a missing
// key where this returns null, and no shared consumer needed it, so mobile's stays in the app).
export { getLocalStorageWithParse } from "@rista/core/utils/localStorage";

export const getParsedLocalStorage = (key) => {
  const lsData = getLocalStorage(key);
  try {
    const parsedData = JSON.parse(lsData);
    return parsedData;
  } catch (error) {
    console.error(`Error parsing localStorage item with key "${key}":`, error);
    return lsData;
  }
}


export const isBluetoothPrinterExists = () => {
  let blePrinterList = getAddedBlePrintersList();
  return blePrinterList.length > 0;
};

// Clears all app localStorage data while preserving device/platform-specific keys
// that should persist across logouts
export function clearAppLsData() {
  // save device/platform values before wiping localStorage
  const isShowOfflineModeToggle = getLocalStorage(LOCALSTORAGE_KEYS.isShowOfflineModeToggle) || "",
    nwPlatform = getLocalStorage(LOCALSTORAGE_KEYS.nwPlatform) || "",
    nwAppVersion = getLocalStorage(LOCALSTORAGE_KEYS.nwAppVersion) || "",
    APP_VERSION = getLocalStorage(LOCALSTORAGE_KEYS.APP_VERSION) || "";
  clearLocalStorage();
  // restore preserved values after clear
  setLocalStorage(LOCALSTORAGE_KEYS.isShowOfflineModeToggle, isShowOfflineModeToggle);
  setLocalStorage(LOCALSTORAGE_KEYS.nwPlatform, nwPlatform);
  setLocalStorage(LOCALSTORAGE_KEYS.nwAppVersion, nwAppVersion);
  setLocalStorage(LOCALSTORAGE_KEYS.APP_VERSION, APP_VERSION);
}
